import { Button } from '@mui/material';
import { styled } from '@mui/material/styles';

export const PolicyStreamButton = styled(Button)(({ theme }) => ({
  borderRadius: theme.spacing(2),
}));
